import { render, staticRenderFns } from "./edit-customer.vue?vue&type=template&id=1d55989f&scoped=true"
import script from "./edit-customer.vue?vue&type=script&lang=js"
export * from "./edit-customer.vue?vue&type=script&lang=js"
import style0 from "./edit-customer.vue?vue&type=style&index=0&id=1d55989f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d55989f",
  null
  
)

export default component.exports